import styled from "styled-components";

export const Container = styled.div`
    .react-pdf__Document {
        display: grid;
        place-items: center
    }
`;

